// A role, drawn as a pill: the header, the account menu and the Team page all
// use this one, so a role looks the same wherever it appears. A color per role,
// none of them amber, which is the Upgrade button's.

import { ROLE_NAMES, normalizeRole } from "../lib/roles";

const TONES = {
  owner: "bg-brand-100 text-brand-800 ring-brand-200",
  admin: "bg-violet-100 text-violet-800 ring-violet-200",
  member: "bg-emerald-100 text-emerald-800 ring-emerald-200",
  reporting: "bg-slate-100 text-slate-700 ring-slate-300"
} as const;

export default function RoleBadge({ role, className = "" }: { role: string | undefined; className?: string }) {
  const known = normalizeRole(role);
  return (
    <span
      data-role={known}
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ring-1 ring-inset ${TONES[known]} ${className}`}
    >
      {ROLE_NAMES[known]}
    </span>
  );
}
